import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import cn from "./cn.json";
import tw from "./tw.json";
import hk from "./hk.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ["querystring", "navigator"],
    },
    debug: false,
    fallbackLng: "en",
    resources: {
      en: {
        translation: en,
      },
      "zh-TW": {
        translation: tw,
      },
      "zh-CN": {
        translation: cn,
      },
      "zh-HK": {
        translation: hk,
      },
    },
  });

export default i18n;
